import { render, staticRenderFns } from "./TableCellBase.vue?vue&type=template&id=e82ee402&"
import script from "./TableCellBase.vue?vue&type=script&lang=js&"
export * from "./TableCellBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e82ee402')) {
      api.createRecord('e82ee402', component.options)
    } else {
      api.reload('e82ee402', component.options)
    }
    module.hot.accept("./TableCellBase.vue?vue&type=template&id=e82ee402&", function () {
      api.rerender('e82ee402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-cells/TableCellBase.vue"
export default component.exports